import React, { Component } from 'react';
import Radium from 'radium';
import Modal from './Modal';
import TextField from './TextField';
import Button from './Button';
import BubbleColorChooser from './BubbleColorChooser';
import BubbleServices from "../services/BubbleServices";

class EditBubble extends Component {

	constructor(props) {
		super(props);
		
		this.state = {
			name: "",
			selectedColor: null
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.visible !== prevProps.visible) {
			if (this.props.bubble) {
				this.setState({
					name: this.props.bubble.title,
					selectedColor: {
						color1: this.props.bubble.color_1,
						color2: this.props.bubble.color_2,
					}
				});
			} else {
				this.setState({
					name: ""
				});
			};
		}
	}

	onSelectColor(color) {
		this.setState({
			selectedColor: color
		});
	}

	onChangeName(val) {
		this.setState({
			name: val
		});
	}

	getTitle() {
		if (this.props.addNew) {
			return "Add Bubble";
		}

		return "Edit Bubble";
	}

	async onAddOrSave() {
		if (!this.state.name || !this.state.selectedColor) {
			return;
		}

		if (this.props.addNew) {
			await BubbleServices.createBubble(this.state.name, this.state.selectedColor.color1, this.state.selectedColor.color2);
			this.props.onReloadUserData();
			this.props.onHide();
		} else {
			// We are saving
			await BubbleServices.editBubble(this.props.bubble.id, this.state.name, this.state.selectedColor.color1, this.state.selectedColor.color2);
			this.props.onReloadUserData();
			this.props.onHide();
		}
	}

	render() {
		if (!this.props.visible) {
			return null;
		}

		return (
			<Modal style={this.props.style} visible={true} onHide={this.props.onHide}>
				<div style={this.localStyles().content}>
					<div>
						<h1>{this.getTitle()}</h1>

						<div>
							<TextField
								style={this.props.style}
								label="Bubble name"
								placeholder="Bubble name"
								value={this.state.name}
								onChange={(val) => this.onChangeName(val)}
							/>

							<BubbleColorChooser
								style={this.props.style}
								selectedColor={this.state.selectedColor}
								onSelectColor={(color) => this.onSelectColor(color)}
							/>
						</div>
					</div>
					
				</div>
				
				<div style={this.localStyles.buttonsHolder}>
					<Button
						title="Save"
						width={150}
						style={this.props.style}
						onClick={() => this.onAddOrSave()}
					/>
				</div>
				
			</Modal>
		)
	}

	localStyles() {
		return {
			content: {
				display: "flex",
				width: "100%",
				height: "80%",
				flex: 1,
				flexDirection: "column",
				justifyContent: "space-between"

			}
		}
	}

}



export default Radium(EditBubble);


// WEBPACK FOOTER //
// ./src/components/EditBubble.js